(function() {

	var productDescription = '#js-product-description';
	var $productDescription = $(productDescription);

	var more = $productDescription.data('more');
	var $more = $(more);

	var params = {
		hiddenElements: '.u-visually-hidden',
		truncateWrapperClass: 'js-truncated',
		truncatedClass: 'is-truncated',
		toggleSpeed: 233,
		toggleSpeedFast: 133
	};

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `returnMargin`
	 *
	 * Defines a context-based margin where context is the threshold.
	 *
	 * @param threshold (int)
	 *
	 * 1. When the case returns `true`.
	 */
	function returnMargin( threshold ) {
		var margin = 0;
		switch( true ) { /* [1] */
			case( threshold < 20 ):
				margin = 2;
				break;
			case( threshold < 30 ):
				margin = 4;
				break;
			default:
				margin = -1;
		}
		return margin;
	}

	/**
	 * @function `truncate`
	 *
	 * Truncates text container, based on a number of lines.
	 *
	 * @param $el (node) - the text-containing element
	 * @param maxLines (int) - the maximum number of lines to show
	 *
	 * 1. Quick escape if the element to truncate does not exist.
	 * 2. Only take into account as direct inner elements those that are rendered
	 *    on screen.
	 * 3. If there are any valid inner elements, truncate container based on them.
	 * 4. Calculate an average line height, in case inner elements don't share the
	 *    same line height.
	 * 5. Tolerance above `maxLines` threshold: if the threshold is set to 4 lines,
	 *    it's stupid to hide just one line.
	 */
	function truncate( $el, maxLines ) {
		if( !$el.length ) { /* [1] */
			return;
		}
		var $toTruncate = $el;
		var $innerElements = $el.children().not(params.hiddenElements); /* [2] */
		var height = 0;
		var lineHeight = 0;
		if( $innerElements.length ) { /* [3] */
			$toTruncate = $innerElements;
		}
		$toTruncate.each(function(i, el) {
			var $el = $(el);
			height += $el.outerHeight();
			lineHeight += parseInt( $el.css('line-height') );
		});
		var averageLineHeight = lineHeight / $toTruncate.length; /* [4] */
		var lines = height / averageLineHeight;
		var extraLines = lines - maxLines;
		if( returnMargin( maxLines ) - extraLines < 0 )	{ /* [5] */
			var maxHeight = maxLines * averageLineHeight;
			$el.wrapInner('<div class="' + params.truncateWrapperClass + '"></div>');
			var $wrapper = $('.'+params.truncateWrapperClass);
			$wrapper.css('height', maxHeight+'px').addClass('is-truncated');
			$more.insertAfter($wrapper);
		}
	}

	/**
	 * @function `expand`
	 *
	 * Expands truncated text to original height to see it in its entirety.
	 *
	 * 1. Temporarily remove any modifiers to calculate the height of the original
	 *    text.
	 * 2. Add them back.
	 * 3. Animate the height from truncated to non-truncated.
	 * 4. When animation is complete, remove all modifiers.
	 */
	function expand( $moreBtn ) {
		var $content = $moreBtn.closest(productDescription)
			.find('.'+params.truncateWrapperClass);
		var truncated_height = $content.css('height');
		var content_height = $content
			.css('height', '')
			.removeClass(params.truncatedClass) /* [1] */
			.outerHeight();
		$moreBtn.slideUp(params.toggleSpeedFast);
		$content
			.css('height', truncated_height)
			.addClass(params.truncateWrapperClass) /* [2] */
			.animate({ /* [3] */
				height: content_height + 'px'
			}, params.toggleSpeed, function() { /* [4] */
				$content.css('height', '');
				$content.removeClass(params.truncatedClass);
			});
	}

	//	======================================================================  //
	//	On fonts loaded
	//	======================================================================  //

	_onFontsLoaded.callbacks.truncate = function() {
		truncate( $productDescription, 7 );
	};

	//	======================================================================  //
	//	On click
	//	======================================================================  //

	_$document.on('click', '.js-more', function() {
		expand( $(this) );
	});

})();
